// UI-internal identifiers for the tenant improvements module. These are
// intentionally NOT translated — they are hash/route fragments, redux
// loading-keys, data-testids, and tab IDs that compose stable contracts
// with tests, route patterns, and the loading slice.
//
// User-visible copy (button labels, headings, error messages) lives at
// each usage site wrapped in `__()` so the localization tooling can pick
// it up via static analysis.

export const PROJECT_TABS = {
  OVERVIEW: 'overview',
  MILESTONES: 'milestones',
  DOCUMENTS: 'documents',
}

export const PROJECT_TAB_ORDER = [
  PROJECT_TABS.OVERVIEW,
  PROJECT_TABS.MILESTONES,
  PROJECT_TABS.DOCUMENTS,
]

// Stable keys consumed by `setLoading` / `unsetLoading` and by Page.Content's
// `loadingKeys` prop. Per-project allowance and documents keys are
// namespaced so two in-flight fetches for different projects do not
// collide in the loading slice (otherwise tab-switching while a previous
// fetch is in flight would mis-attribute the spinner).
export const LOADING_KEYS = {
  TENANT_IMPROVEMENTS: 'tenant-improvements',
  ALLOWANCE_PREFIX: 'tenant-improvements-allowance',
  DOCUMENTS_PREFIX: 'tenant-improvements-documents',
}

export const allowanceLoadingKey = (projectId) =>
  `${LOADING_KEYS.ALLOWANCE_PREFIX}-${projectId}`

export const documentsLoadingKey = (projectId) =>
  `${LOADING_KEYS.DOCUMENTS_PREFIX}-${projectId}`
